// function initSlideshowAutoplayButtons(scope = document) {
//   const slideshowSections = scope.querySelectorAll(".slideshow-section");

//   slideshowSections.forEach((section) => {
//     if (section.dataset.slideshowAutoplayInit === "true") return;
//     section.dataset.slideshowAutoplayInit = "true";

//     const swiperEl = section.querySelector(".swiper");
//     const autoplayButtons = section.querySelectorAll(".slideshow__autoplay");

//     if (!swiperEl) return;

//     let manuallyPaused = false;

//     function getSwiperInstance() {
//       return swiperEl.swiper || null;
//     }

//     function updateAutoplayButtons(swiper) {
//       if (!autoplayButtons.length || !swiper || !swiper.params.autoplay) return;

//       const isRunning = swiper.autoplay && swiper.autoplay.running;

//       autoplayButtons.forEach((btn) => {
//         if (isRunning) {
//           btn.classList.remove("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Pause slideshow");
//         } else {
//           btn.classList.add("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Play slideshow");
//         }
//       });
//     }

//     function stopAllVideos() {
//       section.querySelectorAll(".swiper-slide video").forEach((video) => {
//         video.pause();
//         video.currentTime = 0;
//         video.onended = null;
//       });
//     }

//     function handleActiveSlideVideo(swiper) {
//       if (!swiper) return;

//       stopAllVideos();

//       const activeSlide = swiper.slides[swiper.activeIndex];
//       if (!activeSlide) return;

//       const activeVideo = activeSlide.querySelector("video");

//       if (activeVideo) {
//         if (swiper.params.autoplay && swiper.autoplay && swiper.autoplay.running) {
//           swiper.autoplay.stop();
//         }

//         activeVideo.play().catch(() => {});

//         activeVideo.onended = function () {
//           if (!manuallyPaused) {
//             swiper.slideNext();

//             if (swiper.params.autoplay) {
//               swiper.autoplay.start();
//             }

//             updateAutoplayButtons(swiper);
//           }
//         };

//         autoplayButtons.forEach((btn) => {
//           btn.classList.add("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Play slideshow");
//         });
//       } else {
//         if (!manuallyPaused && swiper.params.autoplay && swiper.autoplay && !swiper.autoplay.running) {
//           swiper.autoplay.start();
//         }

//         updateAutoplayButtons(swiper);
//       }
//     }

//     let retry = 0;
//     const maxRetry = 40;

//     const waitForSwiper = setInterval(() => {
//       const swiper = getSwiperInstance();

//       if (swiper) {
//         clearInterval(waitForSwiper);

//         updateAutoplayButtons(swiper);
//         handleActiveSlideVideo(swiper);

//         autoplayButtons.forEach((btn) => {
//           if (btn.dataset.bound === "true") return;
//           btn.dataset.bound = "true";

//           btn.addEventListener("click", function () {
//             const currentSwiper = getSwiperInstance();
//             if (!currentSwiper || !currentSwiper.params.autoplay) return;

//             const activeSlide = currentSwiper.slides[currentSwiper.activeIndex];
//             const activeVideo = activeSlide ? activeSlide.querySelector("video") : null;

//             if (currentSwiper.autoplay.running) {
//               manuallyPaused = true;
//               currentSwiper.autoplay.stop();

//               if (activeVideo) {
//                 activeVideo.pause();
//               }
//             } else {
//               manuallyPaused = false;

//               if (activeVideo) {
//                 activeVideo.play().catch(() => {});
//               } else {
//                 currentSwiper.autoplay.start();
//               }
//             }

//             updateAutoplayButtons(currentSwiper);
//           });
//         });

//         swiper.on("slideChangeTransitionEnd", function () {
//           handleActiveSlideVideo(swiper);
//         });

//         swiper.on("autoplayStart", function () {
//           updateAutoplayButtons(swiper);
//         });

//         swiper.on("autoplayStop", function () {
//           updateAutoplayButtons(swiper);
//         });
//       }

//       retry++;
//       if (retry >= maxRetry) {
//         clearInterval(waitForSwiper);
//       }
//     }, 250);
//   });
// }

// function initSlideshowAutoplayAndProgress(scope = document) {
//   const slideshowSections = scope.querySelectorAll(".slideshow-section");

//   slideshowSections.forEach((section) => {
//     if (section.dataset.slideshowInit === "true") return;
//     section.dataset.slideshowInit = "true";

//     const swiperEl = section.querySelector(".swiper");
//     const autoplayButtons = section.querySelectorAll(".slideshow__autoplay");

//     if (!swiperEl) return;

//     let manuallyPaused = false;
//     let progressInterval;

//     const getSwiper = () => swiperEl.swiper || null;

//     function updateAutoplayButtons(swiper) {
//       if (!autoplayButtons.length || !swiper || !swiper.params.autoplay) return;
//       const isRunning = swiper.autoplay && swiper.autoplay.running;

//       autoplayButtons.forEach((btn) => {
//         if (isRunning) {
//           btn.classList.remove("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Pause slideshow");
//         } else {
//           btn.classList.add("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Play slideshow");
//         }
//       });
//     }

//     function stopAllVideos() {
//       section.querySelectorAll(".swiper-slide video").forEach((video) => {
//         video.pause();
//         video.currentTime = 0;
//         video.onended = null;
//       });
//     }

//     function handleActiveSlideVideo(swiper) {
//       if (!swiper) return;
//       stopAllVideos();

//       const activeSlide = swiper.slides[swiper.activeIndex];
//       if (!activeSlide) return;

//       const activeVideo = activeSlide.querySelector("video");

//       if (activeVideo) {
//         if (swiper.params.autoplay && swiper.autoplay && swiper.autoplay.running) {
//           swiper.autoplay.stop();
//         }

//         activeVideo.play().catch(() => {});

//         activeVideo.onended = function () {
//           if (!manuallyPaused) {
//             swiper.slideNext();
//             if (swiper.params.autoplay) swiper.autoplay.start();
//             updateAutoplayButtons(swiper);
//           }
//         };

//         autoplayButtons.forEach((btn) => {
//           btn.classList.add("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Play slideshow");
//         });
//       } else {
//         if (!manuallyPaused && swiper.params.autoplay && swiper.autoplay && !swiper.autoplay.running) {
//           swiper.autoplay.start();
//         }
//         updateAutoplayButtons(swiper);
//       }
//     }

//     // --- Progress bar ---
//     function startProgress(swiper) {
//       const activeBullet = section.querySelector(".swiper-pagination-bullet.swiper-pagination-bullet-active");
//       if (!activeBullet) return;

//       let progressBar = activeBullet.querySelector(".progress-bar");
//       if (!progressBar) {
//         const div = document.createElement("div");
//         div.className = "progress-bar";

//         // Position inside bullet
//         div.style.position = "absolute";
//         div.style.display = "block";
//         div.style.bottom = "0";
//         div.style.left = "0";
//         div.style.height = "3px";
//         div.style.width = "0%";
//         div.style.backgroundColor = "#fff";
//         div.style.borderRadius = "2px";
//         div.style.pointerEvents = "none";

//         activeBullet.style.position = "relative"; // parent relative
//         activeBullet.appendChild(div);
//         progressBar = div;
//       }

//       const duration = swiper.params.autoplay?.delay || 3000;
//       const startTime = Date.now();

//       clearInterval(progressInterval);

//       progressInterval = setInterval(() => {
//         const elapsed = Date.now() - startTime;
//         const widthPercent = Math.min((elapsed / duration) * 100, 100);
//         progressBar.style.width = widthPercent + "%";

//         if (widthPercent >= 100) clearInterval(progressInterval);
//       }, 20);
//     }

//     function resetProgress() {
//       section.querySelectorAll(".swiper-pagination-bullet .progress-bar").forEach((bar) => {
//         bar.style.width = "0%";
//       });
//     }

//     // Wait for Swiper instance
//     let retry = 0;
//     const maxRetry = 40;
//     const waitForSwiper = setInterval(() => {
//       const swiper = getSwiper();
//       if (swiper) {
//         clearInterval(waitForSwiper);

//         // Initial setup
//         startProgress(swiper);
//         handleActiveSlideVideo(swiper);
//         updateAutoplayButtons(swiper);

//         // Autoplay buttons
//         autoplayButtons.forEach((btn) => {
//           if (btn.dataset.bound === "true") return;
//           btn.dataset.bound = "true";

//           btn.addEventListener("click", () => {
//             const currentSwiper = getSwiper();
//             if (!currentSwiper || !currentSwiper.params.autoplay) return;

//             const activeSlide = currentSwiper.slides[currentSwiper.activeIndex];
//             const activeVideo = activeSlide ? activeSlide.querySelector("video") : null;

//             if (currentSwiper.autoplay.running) {
//               manuallyPaused = true;
//               currentSwiper.autoplay.stop();
//               if (activeVideo) activeVideo.pause();
//             } else {
//               manuallyPaused = false;
//               if (activeVideo) activeVideo.play().catch(() => {});
//               else currentSwiper.autoplay.start();
//             }

//             updateAutoplayButtons(currentSwiper);
//           });
//         });

//         // Swiper events
//         swiper.on("slideChangeTransitionStart", () => resetProgress());
//         swiper.on("slideChangeTransitionEnd", () => {
//           startProgress(swiper);
//           handleActiveSlideVideo(swiper);
//         });
//         swiper.on("autoplayStop", () => {
//           clearInterval(progressInterval);
//           updateAutoplayButtons(swiper);
//         });
//         swiper.on("autoplayStart", () => {
//           startProgress(swiper);
//           updateAutoplayButtons(swiper);
//         });
//       }

//       retry++;
//       if (retry >= maxRetry) clearInterval(waitForSwiper);
//     }, 250);
//   });
// }

// function initSlideshowAutoplayAndProgress(scope = document) {
//   const slideshowSections = scope.querySelectorAll(".slideshow-section");

//   slideshowSections.forEach((section) => {
//     if (section.dataset.slideshowInit === "true") return;
//     section.dataset.slideshowInit = "true";

//     const swiperEl = section.querySelector(".swiper");
//     const autoplayButtons = section.querySelectorAll(".slideshow__autoplay");

//     if (!swiperEl) return;

//     let manuallyPaused = false;
//     let progressInterval;

//     const getSwiper = () => swiperEl.swiper || null;

//     function updateAutoplayButtons(swiper) {
//       if (!autoplayButtons.length || !swiper || !swiper.params.autoplay) return;
//       const isRunning = swiper.autoplay && swiper.autoplay.running;

//       autoplayButtons.forEach((btn) => {
//         if (isRunning) {
//           btn.classList.remove("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Pause slideshow");
//         } else {
//           btn.classList.add("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Play slideshow");
//         }
//       });
//     }

//     function stopAllVideos() {
//       section.querySelectorAll(".swiper-slide video").forEach((video) => {
//         video.pause();
//         video.currentTime = 0;
//         video.onended = null;
//       });
//     }

//     function handleActiveSlideVideo(swiper) {
//       if (!swiper) return;
//       stopAllVideos();

//       const activeSlide = swiper.slides[swiper.activeIndex];
//       if (!activeSlide) return;

//       const activeVideo = activeSlide.querySelector("video");

//       if (activeVideo) {
//         if (swiper.params.autoplay && swiper.autoplay && swiper.autoplay.running) {
//           swiper.autoplay.stop();
//         }

//         activeVideo.play().catch(() => {});

//         activeVideo.onended = function () {
//           if (!manuallyPaused) {
//             swiper.slideNext();
//             if (swiper.params.autoplay) swiper.autoplay.start();
//             updateAutoplayButtons(swiper);
//           }
//         };

//         autoplayButtons.forEach((btn) => {
//           btn.classList.add("slideshow__autoplay--paused");
//           btn.setAttribute("aria-label", "Play slideshow");
//         });
//       } else {
//         if (!manuallyPaused && swiper.params.autoplay && swiper.autoplay && !swiper.autoplay.running) {
//           swiper.autoplay.start();
//         }
//         updateAutoplayButtons(swiper);
//       }
//     }

//     // --- Progress bar ---
//     function startProgress(swiper) {
//       const activeBullet = section.querySelector(".swiper-pagination-bullet.swiper-pagination-bullet-active");
//       if (!activeBullet) return;

//       let progressBar = activeBullet.querySelector(".progress-bar");
//       if (!progressBar) {
//         const div = document.createElement("div");
//         div.className = "progress-bar";
//         div.style.position = "absolute";
//         div.style.display = "block";
//         div.style.bottom = "0";
//         div.style.left = "0";
//         div.style.height = "3px";
//         div.style.width = "0%";
//         div.style.backgroundColor = "#fff";
//         div.style.borderRadius = "2px";
//         div.style.pointerEvents = "none";

//         activeBullet.style.position = "relative";
//         activeBullet.appendChild(div);
//         progressBar = div;
//       }

//       // Only start progress if autoplay is running
//       if (!swiper.autoplay || !swiper.autoplay.running) {
//         progressBar.style.width = "0%";
//         return;
//       }

//       const duration = swiper.params.autoplay.delay || 3000;
//       const startTime = Date.now();

//       clearInterval(progressInterval);

//       progressInterval = setInterval(() => {
//         if (!swiper.autoplay.running) return;

//         const elapsed = Date.now() - startTime;
//         const widthPercent = Math.min((elapsed / duration) * 100, 100);
//         progressBar.style.width = widthPercent + "%";

//         if (widthPercent >= 100) clearInterval(progressInterval);
//       }, 20);
//     }

//     function resetProgress() {
//       section.querySelectorAll(".swiper-pagination-bullet .progress-bar").forEach((bar) => {
//         bar.style.width = "0%";
//       });
//     }

//     // Wait for Swiper instance
//     let retry = 0;
//     const maxRetry = 40;
//     const waitForSwiper = setInterval(() => {
//       const swiper = getSwiper();
//       if (swiper) {
//         clearInterval(waitForSwiper);

//         // Initial setup
//         startProgress(swiper);
//         handleActiveSlideVideo(swiper);
//         updateAutoplayButtons(swiper);

//         // Autoplay buttons
//         autoplayButtons.forEach((btn) => {
//           if (btn.dataset.bound === "true") return;
//           btn.dataset.bound = "true";

//           btn.addEventListener("click", () => {
//             const currentSwiper = getSwiper();
//             if (!currentSwiper || !currentSwiper.params.autoplay) return;

//             const activeSlide = currentSwiper.slides[currentSwiper.activeIndex];
//             const activeVideo = activeSlide ? activeSlide.querySelector("video") : null;

//             if (currentSwiper.autoplay.running) {
//               manuallyPaused = true;
//               currentSwiper.autoplay.stop();
//               if (activeVideo) activeVideo.pause();
//             } else {
//               manuallyPaused = false;
//               if (activeVideo) activeVideo.play().catch(() => {});
//               else currentSwiper.autoplay.start();
//             }

//             updateAutoplayButtons(currentSwiper);
//           });
//         });

//         // Swiper events
//         swiper.on("slideChangeTransitionStart", () => resetProgress());
//         swiper.on("slideChangeTransitionEnd", () => {
//           startProgress(swiper);
//           handleActiveSlideVideo(swiper);
//         });
//         swiper.on("autoplayStop", () => {
//           clearInterval(progressInterval);
//           updateAutoplayButtons(swiper);
//         });
//         swiper.on("autoplayStart", () => {
//           startProgress(swiper);
//           updateAutoplayButtons(swiper);
//         });
//       }

//       retry++;
//       if (retry >= maxRetry) clearInterval(waitForSwiper);
//     }, 250);
//   });
// }

// final code

function initSlideshowAutoplayAndProgress(scope = document) {
  const slideshowSections = scope.querySelectorAll(".slideshow-section");

  slideshowSections.forEach((section) => {
    if (section.dataset.slideshowInit === "true") return;
    section.dataset.slideshowInit = "true";

    const swiperEl = section.querySelector(".swiper");
    const autoplayButtons = section.querySelectorAll(".slideshow__autoplay");

    if (!swiperEl) return;

    let manuallyPaused = false;
    let progressInterval = null;
    let progressStartTime = 0;
    let pausedElapsed = 0;
    let currentProgressBar = null;
    let isManualResume = false; // prevent duplicate progress start on autoplayStart

    const getSwiper = () => swiperEl.swiper || null;

    function updateAutoplayButtons(swiper) {
      if (!autoplayButtons.length || !swiper || !swiper.params.autoplay) return;

      const isRunning = swiper.autoplay && swiper.autoplay.running;

      autoplayButtons.forEach((btn) => {
        if (isRunning) {
          btn.classList.remove("slideshow__autoplay--paused");
          btn.setAttribute("aria-label", "Pause slideshow");
        } else {
          btn.classList.add("slideshow__autoplay--paused");
          btn.setAttribute("aria-label", "Play slideshow");
        }
      });
    }

    function stopAllVideos() {
      section.querySelectorAll(".swiper-slide video").forEach((video) => {
        video.pause();
        video.currentTime = 0;
        video.onended = null;
      });
    }

    function clearProgressTimer() {
      if (progressInterval) {
        clearInterval(progressInterval);
        progressInterval = null;
      }
    }

    function getOrCreateProgressBar() {
      const activeBullet = section.querySelector(".swiper-pagination-bullet.swiper-pagination-bullet-active");
      if (!activeBullet) return null;

      let progressBar = activeBullet.querySelector(".progress-bar");

      if (!progressBar) {
        progressBar = document.createElement("div");
        progressBar.className = "progress-bar";
        progressBar.style.position = "absolute";
        progressBar.style.display = "block";
        progressBar.style.bottom = "0";
        progressBar.style.left = "0";
        progressBar.style.height = "3px";
        progressBar.style.width = "0%";
        progressBar.style.backgroundColor = "#fff";
        progressBar.style.borderRadius = "2px";
        progressBar.style.pointerEvents = "none";

        activeBullet.style.position = "relative";
        activeBullet.appendChild(progressBar);
      }

      return progressBar;
    }

    function resetAllProgressBars() {
      clearProgressTimer();
      pausedElapsed = 0;
      progressStartTime = 0;
      currentProgressBar = null;

      section.querySelectorAll(".swiper-pagination-bullet .progress-bar").forEach((bar) => {
        bar.style.width = "0%";
      });
    }

    function pauseProgress(swiper) {
      if (!swiper || !swiper.params.autoplay || !currentProgressBar) return;

      clearProgressTimer();

      const duration = swiper.params.autoplay.delay || 3000;
      pausedElapsed = Math.min(pausedElapsed + (Date.now() - progressStartTime), duration);

      const widthPercent = Math.min((pausedElapsed / duration) * 100, 100);
      currentProgressBar.style.width = widthPercent + "%";
    }

    function startProgress(swiper, resume = false) {
      if (!swiper || !swiper.params.autoplay) return;
      if (!swiper.autoplay || !swiper.autoplay.running) return;

      const activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      // Video slide => no progress
      if (activeSlide.querySelector("video")) {
        resetAllProgressBars();
        return;
      }

      const progressBar = getOrCreateProgressBar();
      if (!progressBar) return;

      currentProgressBar = progressBar;
      const duration = swiper.params.autoplay.delay || 3000;

      clearProgressTimer();

      if (!resume) {
        pausedElapsed = 0;
        progressBar.style.width = "0%";
      }

      progressStartTime = Date.now();

      progressInterval = setInterval(() => {
        if (!swiper.autoplay || !swiper.autoplay.running) return;

        const elapsed = pausedElapsed + (Date.now() - progressStartTime);
        const widthPercent = Math.min((elapsed / duration) * 100, 100);

        progressBar.style.width = widthPercent + "%";
    

        if (widthPercent >= 100) {
          clearProgressTimer();
          pausedElapsed = 0;
          progressStartTime = 0;
        }
      }, 0);      
    }

    function handleActiveSlide(swiper, isInitial = false) {
      if (!swiper) return;

      stopAllVideos();
      resetAllProgressBars();

      const activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
      if (!activeSlide) return;

      const activeVideo = activeSlide.querySelector("video");

      if (activeVideo) {
        if (swiper.params.autoplay && swiper.autoplay && swiper.autoplay.running) {
          swiper.autoplay.stop();
        }

        activeVideo.play().catch(() => {});

        activeVideo.onended = function () {
          if (manuallyPaused) return;

          swiper.slideNext();
        };

        autoplayButtons.forEach((btn) => {
          btn.classList.add("slideshow__autoplay--paused");
          btn.setAttribute("aria-label", "Play slideshow");
        });

        return;
      }

      // Normal slide
      if (!manuallyPaused && swiper.params.autoplay && swiper.autoplay && !swiper.autoplay.running) {
        swiper.autoplay.start();
      }

      // Initial load par progress start
      if (isInitial && swiper.autoplay && swiper.autoplay.running) {
        startProgress(swiper, false);
      }

      updateAutoplayButtons(swiper);
    }

    // Wait for Swiper instance
    let retry = 0;
    const maxRetry = 40;

    const waitForSwiper = setInterval(() => {
      const swiper = getSwiper();

      if (swiper) {
        clearInterval(waitForSwiper);

        // Initial setup
        handleActiveSlide(swiper, true);
        updateAutoplayButtons(swiper);

        // Bind autoplay buttons once
        autoplayButtons.forEach((btn) => {
          if (btn.dataset.autoplayBound === "true") return;
          btn.dataset.autoplayBound = "true";

          btn.addEventListener("click", () => {
            const currentSwiper = getSwiper();
            if (!currentSwiper || !currentSwiper.params.autoplay) return;

            const activeSlide = currentSwiper.slides && currentSwiper.slides[currentSwiper.activeIndex];
            const activeVideo = activeSlide ? activeSlide.querySelector("video") : null;
            const isRunning = currentSwiper.autoplay && currentSwiper.autoplay.running;

            if (isRunning) {
              // Pause => freeze at current width
              manuallyPaused = true;
              isManualResume = false;
              currentSwiper.autoplay.stop();

              if (activeVideo) {
                activeVideo.pause();
              } else {
                pauseProgress(currentSwiper);
              }
            } else {
              // Play => resume from same width
              manuallyPaused = false;
              isManualResume = true;

              if (activeVideo) {
                activeVideo.play().catch(() => {});
              } else {
                currentSwiper.autoplay.start();
                startProgress(currentSwiper, pausedElapsed > 0);
              }
            }

            updateAutoplayButtons(currentSwiper);
          });
        });

        // Swiper events
        swiper.on("slideChangeTransitionStart", () => {
          resetAllProgressBars();
        });

        swiper.on("slideChangeTransitionEnd", () => {
          const activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
          const hasVideo = activeSlide && activeSlide.querySelector("video");

          handleActiveSlide(swiper);

          // IMPORTANT: next slide par immediate progress start
          if (!hasVideo && !manuallyPaused && swiper.autoplay && swiper.autoplay.running) {
            startProgress(swiper, false);
          }
        });

        swiper.on("autoplayStart", () => {
          // Skip duplicate start if already manually resumed
          if (isManualResume) {
            isManualResume = false;
            updateAutoplayButtons(swiper);
            return;
          }

          updateAutoplayButtons(swiper);
        });

        swiper.on("autoplayStop", () => {
          clearProgressTimer();
          updateAutoplayButtons(swiper);
        });
      }

      retry++;
      if (retry >= maxRetry) {
        clearInterval(waitForSwiper);
      }
    }, 0);
  });
}


(function () {
  // initSlideshowAutoplayButtons(document);
  initSlideshowAutoplayAndProgress(document);
})();